import { zCurrency } from "@redotech/money/usd-amounts";
import * as z from "zod";

const getBillingCurrencyMigrationInput_ = z.object({});
export const getBillingCurrencyMigrationInput: z.ZodType<GetBillingCurrencyMigrationInput> =
  getBillingCurrencyMigrationInput_;
export interface GetBillingCurrencyMigrationInput extends z.infer<
  typeof getBillingCurrencyMigrationInput_
> {}

const getBillingCurrencyMigrationOutput_ = z.object({
  status: z.enum(["eligible", "already_aligned", "unknown"]),
  /** Currency Shopify invoices this merchant in; the migration target. */
  billingCurrency: zCurrency.nullable(),
  /** Currency the app subscription is denominated in today. */
  subscriptionCurrency: zCurrency.nullable(),
  /** Set while a switch is awaiting the merchant's approval in Shopify. */
  pendingConfirmationUrl: z.string().nullable(),
});
export const getBillingCurrencyMigrationOutput: z.ZodType<GetBillingCurrencyMigrationOutput> =
  getBillingCurrencyMigrationOutput_;
export interface GetBillingCurrencyMigrationOutput extends z.infer<
  typeof getBillingCurrencyMigrationOutput_
> {}

export const getBillingCurrencyMigration = {
  name: "getBillingCurrencyMigration" as const,
  input: getBillingCurrencyMigrationInput,
  output: getBillingCurrencyMigrationOutput,
};
